import { createContext, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
const ModalContext = createContext();
export const ModalContextProvider = ({ children }) => {

  const [isloadingconnect, setIsloadingconnect] = useState(false)
  const [balance, setBalance] = useState()
  const [userDetails, setUserDetails] = useState()
  const [apiRes, setApiRes] = useState()
  const [search, setSearch] = useState("");
  const [isBuyToken, setIsBuyToken] = useState(false)
  const [check, setCheck] = useState(false)
    const [topUpLevelsModal, setTopUpLevelsModal] = useState(false);

const [modalConnectWallet, setModalConnectWallet]=useState(false)
    const [isOpenMenu, setIsOpenMenu] = useState(false);
    const [referralCode, setReferralCode] = useState(false);


  const contextValue = useMemo(() => ({
    isloadingconnect, setIsloadingconnect,
    balance, setBalance,
    userDetails, setUserDetails,
    apiRes, setApiRes,
    search, setSearch,
    isBuyToken, setIsBuyToken,
    check, setCheck,
    topUpLevelsModal, setTopUpLevelsModal,
    modalConnectWallet, setModalConnectWallet,
    isOpenMenu, setIsOpenMenu,
    referralCode, setReferralCode

  }), [isloadingconnect, balance, userDetails, apiRes,search, isBuyToken,check,topUpLevelsModal, setTopUpLevelsModal,modalConnectWallet,isOpenMenu,referralCode, setReferralCode]);
  return (
    <ModalContext.Provider value={contextValue}>
      {children}
    </ModalContext.Provider>
  );
};
ModalContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
export const useModalContext = () => useContext(ModalContext); 